// extracted by mini-css-extract-plugin
export var box = "_28-1";
export var checkboxRow = "_28-8";
export var checked = "_28-2";
export var descriptionSpacer = "_28-a";
export var disabled = "_28-3";
export var icon = "_28-6";
export var input = "_28-0";
export var labelSpacer = "_28-9";
export var medium = "_28-5";
export var small = "_28-4";
export var text = "_28-7";